import React, { useEffect, useState } from 'react';
import cN from 'classnames';
import styles from '../styles.module.scss';
import '@magaele/ic-ln/css.css';
import { useMediaQuery } from 'react-responsive';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { I_Filter, I_SearchFilter } from '@Redux/search/interfaces';
import { setFilterData } from '@Redux/search/actions';

import { Checkbox } from '@lion-design/core';

interface ItemInfo {
    text: string; // 項目名稱
    value: string | number; // 項目value
    filterType: string; // 項目所屬大項
}

interface I_CheckboxItemProps extends ItemInfo {
    cols: string;
    hide?: boolean;
    note?: string;
    price?: number;
    currency?: string;
    curSeq?: number; // 去回程機場選項當前航段
    isDisable?: boolean; // 是否要disabled
    tempMFilter?: any;
    setTempMFilter?: Function;
}

const CheckboxItem = (props: I_CheckboxItemProps) => {
    const { text, value, filterType } = props;
    const { note, price, currency, cols, hide, curSeq, isDisable } = props;
    const { tempMFilter, setTempMFilter } = props;

    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const dispatch = useDispatch();
    const { FilterData } = useSelector((state: RootState) => state.search);

    const deviceFilter: I_SearchFilter = isMobile ? tempMFilter : FilterData;
    const setDeviceFilter = (newFilter: any) => {
        if (!isMobile) dispatch(setFilterData(newFilter));
        if (isMobile && setTempMFilter) setTempMFilter(newFilter);
    };

    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        let isFiltered;
        let mobileTempFiltered;

        if (curSeq) {
            const targetSeqItemPC = FilterData?.seqAirport?.find(
                (seqItem: any) => seqItem.seqNum === curSeq
            );
            const targetSeqItemM = tempMFilter?.seqAirport?.find(
                (seqItem: any) => seqItem.seqNum === curSeq
            );
            isFiltered =
                targetSeqItemPC &&
                targetSeqItemPC[filterType].some((c: { value: string }) => c.value == value);

            mobileTempFiltered =
                targetSeqItemM &&
                targetSeqItemM[filterType].some((c: { value: string }) => c.value == value);
        } else {
            isFiltered =
                FilterData &&
                FilterData[filterType] &&
                FilterData[filterType].some((c: { value: string }) => c.value == value);

            mobileTempFiltered =
                tempMFilter &&
                tempMFilter[filterType] &&
                tempMFilter[filterType].some((c: { value: string }) => c.value == value);
        }

        if (isMobile) setIsChecked(mobileTempFiltered);
        if (!isMobile) setIsChecked(isFiltered);
    }, [FilterData, tempMFilter]);

    const checkboxChange = (active: boolean) => {
        const newFilterData = deviceFilter ? JSON.parse(JSON.stringify(deviceFilter)) : {};

        // 分航段去回程
        if (curSeq) {
            if (!newFilterData.seqAirport) {
                newFilterData.seqAirport = [];
            }

            if (
                newFilterData.seqAirport.findIndex(
                    ({ seqNum }: { seqNum: number }) => seqNum === curSeq
                ) === -1
            ) {
                newFilterData.seqAirport.push({
                    seqNum: curSeq,
                    departure: [],
                    arrival: [],
                });
            }

            const targetSeqItem = newFilterData.seqAirport.find(
                (seqItem: any) => seqItem.seqNum === curSeq
            );

            if (active) {
                targetSeqItem[filterType].push({
                    text: text,
                    value: value,
                    checked: active,
                });
            } else {
                targetSeqItem[filterType] = targetSeqItem[filterType].filter(
                    (type: I_Filter) => type.value !== value
                );
            }

            return setDeviceFilter(newFilterData);
        }

        if (!newFilterData[filterType]) {
            if (active) {
                newFilterData[filterType] = [
                    {
                        text: text,
                        value: value,
                        checked: active,
                    },
                ];
            }
        } else {
            if (active) {
                newFilterData[filterType].push({
                    text: text,
                    value: value,
                    checked: active,
                });
            } else {
                newFilterData[filterType] = newFilterData[filterType].filter(
                    (type: I_Filter) => type.value !== value
                );
            }
        }

        setDeviceFilter(newFilterData);
    };

    const itemInfo = () => {
        return (
            <>
                <span>{text}</span>
                {note && price && (
                    <span className={styles.Note}>
                        <span className={styles.Price}>{`${currency}${price}`}</span>
                        {note}
                    </span>
                )}
            </>
        );
    };

    return (
        <li className={cN(styles.CheckBoxWrap, styles[cols], { hide: hide })}>
            <Checkbox
                title={itemInfo()}
                checkFillColor="#f03742"
                checkedBackgroundColor="transparent"
                disabled={isDisable ? isDisable : false}
                checked={isChecked}
                onChange={(active: boolean) => {
                    checkboxChange(active);
                }}
            />
        </li>
    );
};

export default CheckboxItem;
